import { createAction, props } from '@ngrx/store'
import { OrderElement } from './orderelement'
export enum OrderInfoTypes {
  ORDERS_INFO_LOAD = '[ORDERS_INFO] Load Orders Info',
  ORDERS_INFO_SUCCESS = '[ORDERS_INFO] Order Info Successfully Loaded',
  ORDERS_INFO_FAIL = '[ORDERS_INFO] Loading Order Info failed',
}
export const OrderInfoActions = {
  orderInfoLoad: createAction(OrderInfoTypes.ORDERS_INFO_LOAD, props<{ payload: string }>()),
  orderInfoSuccess: createAction(OrderInfoTypes.ORDERS_INFO_SUCCESS, props<{ payload: OrderElement[] }>()),
  orderInfoFail: createAction(OrderInfoTypes.ORDERS_INFO_FAIL),
} as const
